// extracted by mini-css-extract-plugin
export var leftAlign = "_i-2";
export var popper = "_i-0";
export var subtitle = "_i-1";